module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-hairmakerehearsal-c90ff7c7055f8df59842c8ff856eb7ae.jpg";